import createClient from 'openapi-fetch';
import { auth } from '@/core/firebaseInit';
import { paths } from './generated';

export const apiClient = createClient<paths>({ baseUrl: process.env.VUE_APP_API_URL });

apiClient.use({
  onRequest: async ({ request }) => {
    const token = await auth.currentUser?.getIdToken();
    if (token) {
      request.headers.set('Authorization', `Bearer ${token}`);
    }

    return request;
  },
});
